import { Link, Paper, styled } from "@mui/material";
import { useTranslation } from "react-i18next";

import { LoadingButton } from "components/buttons/LoadingButton";

interface Props {
  isDisabled: boolean;
  isLoading: boolean;
  onCancel: () => void;
  handleSave: () => void;
}

export function AddUploadedMeasuresFooter(props: Props) {
  const { handleSave, onCancel, isDisabled, isLoading } = props;
  const { t } = useTranslation();

  return (
    <StyledPaper elevation={0}>
      <Link onClick={onCancel}>{t("label.cancel")}</Link>
      <LoadingButton
        variant="green-contained"
        isLoading={isLoading}
        disabled={isDisabled}
        onClick={handleSave}
      >
        {t("label.save")}
      </LoadingButton>
    </StyledPaper>
  );
}

const StyledPaper = styled(Paper)`
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing(2)};
  flex-grow: 1;
  align-items: center;
  justify-content: flex-end;
  .MuiButton-root {
    display: inline-flex;
    gap: ${({ theme }) => theme.spacing(2)};
  }
`;
